import { useFloating, autoUpdate } from '@floating-ui/react';
import type { Placement } from '../config/get-config-popper';
import { getConfigPopper } from '../config/get-config-popper';

const useModalPosition = (
    boxRef: Element,
    placement?: Placement,
    isPortalled = false,
) => {
    const {
        placement: resolvedPlacement,
        strategy,
        middleware,
    } = getConfigPopper(boxRef, placement, isPortalled);

    const {
        refs,
        floatingStyles,
        update,
        placement: finalPlacement,
        isPositioned,
    } = useFloating({
        placement: resolvedPlacement,
        strategy,
        middleware,
        // react-popper had eventListeners { scroll: false }: in-box UI moves
        // with the box anyway. Portalled UI lives on <body>, so it has to
        // follow a scrolling ancestor of the tag itself.
        whileElementsMounted: (reference, floating, updatePosition) =>
            autoUpdate(reference, floating, updatePosition, {
                ancestorScroll: isPortalled,
            }),
    });

    return {
        setReferenceElement: refs.setReference,
        setPopperElement: refs.setFloating,
        floatingStyles,
        update,
        placement: finalPlacement,
        isPositioned,
    };
};

export default useModalPosition;
